<template>
  <div class="accordion-item" :class="{expanded: isExpanded}">
    <div class="accordion-item-header" @click="onHeaderClick">
      <slot name="header"></slot>
      <a class="toggler"></a>
    </div>
    <div class="accordion-item-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccordionItem",
  props: ["expanded", "value"],
  data() {
    return {
        isExpanded: !!this.$props.expanded 
    };
  },
  methods: {
    onHeaderClick () {
      this.$emit("toggle", this, this.$props.value);
    }
  },
  watch: {
    expanded (val) {
      this.isExpanded = val;
    }
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.accordion-item {
    width: 100%;
  align-items: center;
  color: black;
  margin-bottom: 15px;
  box-sizing: border-box;
  box-shadow: 0px 1px 3px 0px rgba(224,224,224,1);
}

.accordion-item-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 15px;
    background-color: #f7f7f7;
    box-sizing: border-box;
    cursor: pointer;
}

.accordion-item:not(.expanded):hover {
    box-shadow: 0px 1px 5px 0px rgba(204,204,204,1);
}

.accordion-item.expanded {
    box-shadow: 0px 3px 10px 5px rgba(204,204,204,1);
}

.accordion-item-header > div:first-of-type{
    flex-grow: 1;
}

.accordion-item.expanded > .accordion-item-header {
  border-bottom: 1px solid #e4e4e4;
}

.accordion-item > .accordion-item-header > .toggler {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='70' height='70'%3E%3Cpath fill='none' d='M-1-1h582v402H-1z'/%3E%3Cg%3E%3Cpath fill='none' stroke='%232655FF' stroke-linecap='round' stroke-miterlimit='10' stroke-width='3' d='M41.6 49.1L28.2 35.7c-.4-.4-.4-1 0-1.4l13.4-13.4'/%3E%3C/g%3E%3C/svg%3E");
   width: 32px;
   height: 32px;
   margin: 0 20px;
   background-size: contain;
   animation:spincw 0.5s;
}

.accordion-item.expanded > .accordion-item-header > .toggler {
    animation:spinccw 0.5s;
    transform: rotate(-90deg);
}

@keyframes spincw {
    from { transform: rotate(-90deg); }
    to { transform: rotate(0); }
}

@keyframes spinccw {
    from { transform: rotate(0deg); }
    to { transform: rotate(-90deg); }
}

.accordion-item > .accordion-item-content {
  max-height: 0;
  height:auto;
  overflow: hidden;
  box-sizing: border-box;
}

.accordion-item.expanded > .accordion-item-content {
  animation: expand 1s;
  max-height: 1000px;
  padding: 15px;
  overflow: auto;
}

@keyframes expand {
  from {max-height: 0;overflow: hidden;}
  to {max-height: 1000px;overflow: auto;}
}

</style>